<template>
  <div class="time-picker-wrapper time-text">
    <span>De</span>
    <mf-icon small color="marca-0-l40">schedule</mf-icon>
    <span class="text-picker" @click.stop="openTimePicker('initial_hour')">{{ initial_hour }}</span>
    <span>até</span>
    <mf-icon small color="marca-0-l40">schedule</mf-icon>
    <span class="text-picker" @click.stop="openTimePicker('final_hour')">{{ final_hour }}</span>
    <v-dialog v-model="timePickerDialog" width="290">
      <v-card>
        <v-time-picker :key="`timer-${timerPickerKey}`" v-model="selectedTime" :disabled="disabled" format="24hr" :min="minHour" :max="maxHour"></v-time-picker>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="timePickerDialog = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="setTime">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timePickerDialog: false,
      selectedTime: '',
      editingField: '',
      timerPickerKey: 0,
    }
  },
  computed: {
    initial_hour: {
      get() {
        return this.settings.initial_hour
      },
    },
    final_hour: {
      get() {
        return this.settings.final_hour
      },
    },
    minHour() {
      if (this.editingField === 'initial_hour') return '06:00'
      else {
        if (this.initial_hour) {
          let [hour, minutes] = this.initial_hour.split(':').map(Number)
          hour += 1
          return this.formatTime(hour, minutes)
        } else {
          return '07:00'
        }
      }
    },
    maxHour() {
      if (this.editingField === 'final_hour') return '23:00'
      else return '22:00'
    },
  },
  watch: {
    initial_hour(newTime) {
      if (!newTime) return
      let [hour, minutes] = newTime.split(':').map(Number)
      hour += 1
      this.$emit('update-header', { updateDispatchModel: 'updateHourSettings', value: { final_hour: this.formatTime(hour, minutes) } })
    },
  },
  methods: {
    openTimePicker(field) {
      this.editingField = field
      this.selectedTime = this[field]
      this.timePickerDialog = true
    },
    formatTime(hour, minutes) {
      return `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
    },
    setTime() {
      if (this.editingField === 'initial_hour' && this.selectedTime) {
        this.$emit('update-header', { updateDispatchModel: 'updateHourSettings', value: { initial_hour: this.selectedTime } })
      } else if (this.editingField === 'final_hour' && this.selectedTime) {
        this.$emit('update-header', { updateDispatchModel: 'updateHourSettings', value: { final_hour: this.selectedTime } })
      }
      this.selectedTime = ''
      this.editingField = ''
      this.timerPickerKey += 1
      this.timePickerDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.time-picker-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.time-text {
  color: $cinza-d20;
}
</style>
